<!-- 通用支付结果页 -->
<template>
  <div class="thrid-pay-result">
    <img class="payback-icon success-icon" :src="icon">
    <h1 class="payback-title">{{text}}</h1>

    <div class="goods" v-if="goodsId">
      <div class="main">
        <div class="main-inner">
          <h1 class="title">{{name}}</h1>
          <p class="tip">消费金额</p>
        </div>
      </div>
      <div class="left">
        <div class="goods-pic" v-if="!goodsIcon && goodsType === 'vip'"></div>
        <img :src="goodsIcon" class="goods-icon" :onerror="defaultCoverUrl" alt="cover" v-if="goodsIcon">
      </div>
      <div class="right">
        <p class="unit-price"><span class="num">{{account}}元</span></p>
      </div>
    </div>

    <div class="btn-payback" @click="goPayBackPath">确认</div>

    <img class="logo-more" src="@/assets/global/logo-more.png">
  </div>
</template>

<script>
import config from '@/config/config'
import { getGoodsInfo } from '@/api/goods'
import { getOrder } from '@/api/order'

export default {
  data () {
    return {
      icon: '',
      text: '',
      goodsId: '',
      content: '',
      desc: '',
      name: '',
      price: '',
      priceLabel: '',
      account: '',
      goodsType: '',
      defaultCoverUrl: 'this.src="' + require('../../assets/global/error.jpg') + '"',
      goodsIcon: '',
    }
  },
  created() {
    this.$daidiLoading.hide()
    this.checkPayResult()
    this.getOrderInfo(this.$route.query.order_id)
  },
  mounted() {

  },
  methods: {
    async getOrderInfo(orderId) {
      let orderInfo = await getOrder(orderId)
      let goodsId = orderInfo.order.good_id
      await this.getGoodsInfo(goodsId)
    },

    async getGoodsInfo(goodsId) {
      let goodsInfo = await getGoodsInfo(goodsId, this.$store.getters.token)
      goodsInfo = goodsInfo.good_info
      this.goodsId = goodsInfo.good_id
      this.goodsType = goodsInfo.obj_type
      this.content = goodsInfo.good_content || ''
      this.desc = goodsInfo.good_desc || ''
      this.name = goodsInfo.good_name || ''
      this.price = goodsInfo.good_price
      this.priceLabel = goodsInfo.good_price_label
      this.account = goodsInfo.account
      if (goodsInfo.good_icon) this.goodsIcon = goodsInfo.good_icon
    },

    checkPayResult() {
      let payResult = this.$route.query.payResult
      switch (payResult) {
        case 'cancel':
          this.text = '支付已取消'
          this.icon = require('../../assets/payResult/icon-error.png')
          break
        case 'fail':
          this.text = '支付失败，请重试'
          this.icon = require('../../assets/payResult/icon-error.png')
          break
        case 'ok':
          this.text = '支付成功'
          this.icon = require('../../assets/payResult/icon-success.png')
          break
        default:
          this.text = '支付失败，未知错误'
          this.icon = require('../../assets/payResult/icon-error.png')
      }
    },

    goPayBackPath(payResult) {
      let orderPayBackPath = decodeURIComponent(this.$route.query.order_payback_url)
      let path = /^https?:\/\//.test(orderPayBackPath) ? orderPayBackPath : `${config.siteRoot}${orderPayBackPath}`
      location.href = path
    }
  },
}
</script>

<style scoped lang="less">
  @import "~@/styles/fn";
  @line: 1px dashed rgba(0,0,0,.16);

  .thrid-pay-result {
    padding: 1.28rem .48rem .64rem .48rem;
    min-height: 100vh;
    background: #f4f4f8;
    text-align: center;
    box-sizing: border-box;
  }
  .payback-icon {
    display: block;
    margin: 0 auto;
    width: 1.92rem;
    height: 1.92rem;
  }
  .payback-title {
    display: block;
    margin-top: .32rem;
    font-size: .44rem;
    color: #6c6c74;
    font-weight: bold;
  }
  hr {
    display: block;
    margin: 0 auto;
    margin-top: .96rem;
    height: 1px;
    border: none;
    border-top: .01rem solid rgba(0,0,0,.1);
  }
  .payback-tip {
    display: block;
    margin: 0 auto;
    margin-top: .64rem;
    color: #6c6c74;
    font-size: .34rem;
    font-weight: normal;
  }
  .btn-payback {
    display: block;
    margin: 0 auto;
    margin-top: .88rem;
    max-width: 6.54rem;
    height: 1.12rem;
    line-height: 1.12rem;
    background: #fedc42;
    color: #604038;
    font-size: .34rem;
    font-weight: bold;
    border-radius: 200px;
  }
  .logo-more {
    display: block;
    position: absolute;
    left: 50%;
    bottom: .64rem;
    transform: translateX(-50%);
    margin: 0 auto;
    width: 2.8rem;
  }

  .goods {
    @right_w: 1.8rem;
    @left_w: 1.44rem;
    @box_h: 1.44rem;
    display: block;
    position: relative;
    margin-top: .64rem;
    padding: .24rem 0;
    width: 100%;
    min-height: 1.2rem;
    text-align: left;
    border-top: @line;
    border-bottom: @line;
    box-sizing: border-box;
    overflow: hidden;
    .main, .left, .right {
      float: left;
      min-height: @box_h;
    }
    .left {
      margin-left: -100%;
      width: @left_w;
      .goods-pic {
        display: block;
        width: 1.44rem;
        height: 1.44rem;
        .bg("~@/assets/order/order-icon.png");
      }
      .goods-icon {
        display: block;
        width: 1.44rem;
        height: 1.44rem;
        border-radius: 3px;
      }
    }
    .right {
      position: relative;
      margin-left: -@right_w;
      width: @right_w;
      .unit-price {
        padding-top: .8rem;
        font-size: .34rem;
        color: #fe4010;
        text-align: right;
      }
    }
    .main {
      width: 100%;
      &-inner {
        margin-left: @left_w;
        margin-right: @right_w;
        padding-left: .28rem;
        min-height: @box_h;
        word-break: break-all;
        .title {
          // padding-top: .1rem;
          font-size: .4rem;
          color: #6c6c74;
        }
        .tip {
          padding-top: .16rem;
          text-align: left;
          font-size: .28rem;
          color: #a0a0a6;
        }
      }
    }
  }
</style>
